import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _filter from 'lodash/filter';
import _sortBy from 'lodash/sortBy';
import ErrorMessage from '@minecraft.error-message';
import { useDrawerSearchFilterNameOrCategory, useDrawerGlobalLoader } from '@minecraft.drawer';
import { QUERY_CONFLICTS } from '../../../FilterBasic/FilterBasicCollection/FilterBasicCollectionGraphQL';
import { FiltersNameEnum } from '../../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../../shared/utils';
import { FormItem } from '../../../shared/styles';
import { FilterDrawerType, FiltersCategoryNameEnum } from '../../shared/types';
import { useFiltersLabel } from '../../shared/hooks/useFiltersLabel';
import { Conflicts } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const ExcludeTalentWithConflictsCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, loading, error } = useQuery(QUERY_CONFLICTS);

  const conflictsOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(
        _filter(data?.conflicts, (conflict) => conflict.enabled),
        'sortOrder'
      ),
      'name'
    );
  }, [data?.conflicts]);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.excludeTalentWithConflicts
  );

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (conflictsOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.excludeConflicts]: conflictsOptions,
      });
    }
  }, [conflictsOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <Conflicts
          name={FiltersNameEnum.excludeConflicts}
          label={filtersLabelOfAudience[FiltersNameEnum.excludeConflicts]}
        />
      </FormItem>
    )
  );
};

export default ExcludeTalentWithConflictsCategory;
